<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="manufacture-equipment-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <!-- Manufacture Reference (FORM02: manufacture_equipment.cat_emcr_manufacturers) -->
      <div v-if="isTableVisible(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD)" :class="showEquipment ? 'col-md-6' : 'col-12'">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Manufacture Reference <span v-if="isTableMandatory(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[MANUFACTURERS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px">
              <!-- MPN Number: hasil integrasi (bukan input user), cuma ditampilkan kalau ada baris yang punya. Tetap ikut
                   payload (config visible) supaya tidak hilang saat Save -- endpoint membuat ulang semua baris. -->
              <Column v-if="hasMpnNumber && isColumnVisibleFn('mpn_number', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(150)">
                <template #header>MPN Number</template>
                <template #body="{ data }">
                  <InputText :model-value="data.mpn_number || ''" size="small" disabled fluid />
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('manufacture', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(250)">
                <template #header>
                  Manufacture <span v-if="isColumnMandatoryFn('manufacture', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <!-- Dataset besar: search-as-you-type (searchAsYouTypeColumns), hasil cari digabung ke opsi bersama. -->
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.manufacture" size="small" fluid filter
                    :options="dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture', data)]"
                    option-label="label" option-value="value" placeholder="Search Manufacturer"
                    :loading="dialog.loading[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture', data)]"
                    :invalid="isColumnInvalidFn(data, 'manufacture')"
                    :disabled="disabled || !isColumnEnabledFn('manufacture', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                    @show="loadColumnOptions(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture', data)"
                    @filter="searchColumnOptions($event, MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('manufacture_ref', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(200)">
                <template #header>
                  Manufacture Reference <span v-if="isColumnMandatoryFn('manufacture_ref', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <!-- Maks. karakter dari rules max_length config (awalan "(S)" tidak dihitung); awalan (value_prefix, Type Z2) dipasang saat selesai mengetik. -->
                  <InputText v-model="data.manufacture_ref" size="small" placeholder="Eg: 6203" fluid
                    :maxlength="columnMaxLength(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture_ref', data)"
                    :invalid="isColumnInvalidFn(data, 'manufacture_ref')"
                    :disabled="disabled || !isColumnEnabledFn('manufacture_ref', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                    @input="data.manufacture_ref = (data.manufacture_ref || '').toUpperCase()"
                    @blur="applyLockedValues()"
                  />
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('manufacture_ref_description', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(200)">
                <template #header>
                  Manufacture Ref Description <span v-if="isColumnMandatoryFn('manufacture_ref_description', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <InputText v-model="data.manufacture_ref_description" size="small" placeholder="Ref Description" fluid
                    :maxlength="columnMaxLength(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'manufacture_ref_description', data)"
                    :invalid="isColumnInvalidFn(data, 'manufacture_ref_description')"
                    :disabled="disabled || !isColumnEnabledFn('manufacture_ref_description', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                    @input="data.manufacture_ref_description = (data.manufacture_ref_description || '').toUpperCase()"
                    @blur="applyLockedValues()"
                  />
                </template>
              </Column>
              <template v-for="col in MANUFACTURER_SELECT_COLUMNS" :key="col.column">
                <Column v-if="isColumnVisibleFn(col.column, MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(col.width)">
                  <template #header>
                    {{ col.label }} <span v-if="isColumnMandatoryFn(col.column, MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                  </template>
                  <template #body="{ data }">
                    <SelectPrime show-clear v-model="data[col.column]" size="small" fluid filter
                      :options="dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, col.column, data)]"
                      option-label="label" option-value="value" :placeholder="`Select ${col.label}`"
                      :loading="dialog.loading[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, col.column, data)]"
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                      @show="loadColumnOptions(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, col.column, data)"
                      @change="onColumnChange(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, col.column, data)"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, col.column, data)], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                  </template>
                </Column>
              </template>
              <Column v-if="isColumnVisibleFn('position', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(110)">
                <template #header>
                  Position <span v-if="isColumnMandatoryInRows(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'position')" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <InputNumber :model-value="toNumberValue(data.position)" @update:model-value="data.position = $event" size="small" placeholder="Eg: 36" :use-grouping="false" fluid
                    :invalid="isColumnInvalidFn(data, 'position')"
                    :disabled="disabled || !isColumnEnabledFn('position', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                  />
                </template>
              </Column>
              <!-- valid_start tidak ditampilkan: diisi default_value (hari ini) saat baris ditambah, tetap ikut payload. -->
              <Column v-if="isColumnVisibleFn('valid_until', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(190)">
                <template #header>
                  Valid Until <span v-if="isColumnMandatoryFn('valid_until', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <Calendar :model-value="toDateValue(data.valid_until)" show-icon date-format="dd/mm/yy" placeholder="DD/MM/YYYY" fluid
                    :invalid="isColumnInvalidFn(data, 'valid_until')"
                    :disabled="disabled || !isColumnEnabledFn('valid_until', MANUFACTURERS_FIELD, MANUFACTURE_EQUIPMENT_TAB) || isColumnLocked(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD, 'valid_until', data)"
                    @update:model-value="data.valid_until = fromDateValue($event)"
                  />
                </template>
              </Column>
              <!-- Baris yang sudah punya MPN Number (sudah terintegrasi) tidak boleh dihapus. Kolom tampil sesuai row_actions. -->
              <Column v-if="canRemoveRow(MANUFACTURE_EQUIPMENT_TAB, MANUFACTURERS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ data, index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled || hasValue(data.mpn_number)" @click="removeRow(MANUFACTURERS_FIELD, index)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>

      <!-- Equipment (FORM02: manufacture_equipment.cat_emcr_equipments) -->
      <div v-if="showEquipment" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Equipment <span v-if="isTableMandatory(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[EQUIPMENTS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="400px">
              <Column v-if="isColumnVisibleFn('plant', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(150)">
                <template #header>
                  Plant <span v-if="isColumnMandatoryFn('plant', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <!-- Opsi = plant yang sudah dipilih di tabel Plant (data_source detail_array, source "form"), sama seperti tabel Location. -->
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.plant" size="small" fluid
                    :options="dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'plant', data)]"
                    option-label="label" option-value="value" placeholder="Select Plant"
                    :invalid="isColumnInvalidFn(data, 'plant')"
                    :disabled="disabled || !isColumnEnabledFn('plant', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                    @show="loadColumnOptions(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'plant', data)"
                    @change="onColumnChange(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'plant', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'plant', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('equipment', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(260)">
                <template #header>
                  Equipment Code <span v-if="isColumnMandatoryFn('equipment', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <!-- Opsi difilter plant BARIS ini (params ["client","plant"] + depends_on ["plant"]), search-as-you-type. -->
                <template #body="{ data }">
                  <SelectPrime show-clear v-model="data.equipment" size="small" fluid filter
                    :options="dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'equipment', data)]"
                    option-label="label" option-value="value" placeholder="Search Equipment"
                    :loading="dialog.loading[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'equipment', data)]"
                    :invalid="isColumnInvalidFn(data, 'equipment')"
                    :disabled="disabled || !isColumnEnabledFn('equipment', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB) || !isColumnDependencyReadyFn('equipment', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB, data)"
                    @show="loadColumnOptions(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'equipment', data)"
                    @filter="searchColumnOptions($event, MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'equipment', data)"
                  >
                    <template #value="{ value, placeholder }">
                      <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD, 'equipment', data)], value) }}</span>
                      <span v-else>{{ placeholder }}</span>
                    </template>
                  </SelectPrime>
                </template>
              </Column>
              <Column v-if="isColumnVisibleFn('qty_installed', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" header-class="bg-light text-center" :style="columnWidth(120)">
                <template #header>
                  Qty Installed <span v-if="isColumnMandatoryFn('qty_installed', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)" class="exclamation-mark-error-tab">*</span>
                </template>
                <template #body="{ data }">
                  <InputNumber :model-value="toNumberValue(data.qty_installed)" @update:model-value="data.qty_installed = $event" size="small" placeholder="Eg: 12" :use-grouping="false" fluid
                    :invalid="isColumnInvalidFn(data, 'qty_installed')"
                    :disabled="disabled || !isColumnEnabledFn('qty_installed', EQUIPMENTS_FIELD, MANUFACTURE_EQUIPMENT_TAB)"
                  />
                </template>
              </Column>
              <Column v-if="canRemoveRow(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(EQUIPMENTS_FIELD, index)" />
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formConfigHelper from "@/helpers/New_formConfig";
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";

// Key tab & field repeatable di FORM02_BASE.json
const MANUFACTURE_EQUIPMENT_TAB = "manufacture_equipment";
const MANUFACTURERS_FIELD = "cat_emcr_manufacturers";
const EQUIPMENTS_FIELD = "cat_emcr_equipments";

// Kolom select dataset kecil di tabel Manufacture (preload biasa, pola sama -> 1 blok template). Layout, bukan config.
const MANUFACTURER_SELECT_COLUMNS = [
  { column: "source_type", label: "Source Type", width: 160 },
  { column: "manref_type", label: "Type", width: 160 }
];

// Kolom dataset besar: search-as-you-type (keputusan template, DECISIONS_LOG.md "Field dataset besar...").
const SEARCH_AS_YOU_TYPE_COLUMNS = new Set([`${MANUFACTURERS_FIELD}.manufacture`, `${EQUIPMENTS_FIELD}.equipment`]);

// Props, setup engine, dialog, bind ke mcrItem, addRow/removeRow/opsi kolom: kerangka bersama New_CataloguerTab.js.
export default {
  name: "ManufactureEquipmentTab",
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props, (vm) => ({
      // data_source detail_array dengan source "form" (opsi Plant di tabel Equipment) dibaca dari state item ini.
      getDetailSources: () => ({ form: vm.dialog.form })
    }));
  },
  data() {
    return {
      MANUFACTURE_EQUIPMENT_TAB,
      MANUFACTURERS_FIELD,
      EQUIPMENTS_FIELD,
      MANUFACTURER_SELECT_COLUMNS,
      searchAsYouTypeColumns: SEARCH_AS_YOU_TYPE_COLUMNS,
      dialog: createTabDialog(this.mcrItem)
    };
  },
  computed: {
    hasMpnNumber() {
      return (this.mcrItem?.[MANUFACTURERS_FIELD] || []).some((row) => this.hasValue(row.mpn_number));
    },
    showEquipment() {
      return this.isTableVisible(MANUFACTURE_EQUIPMENT_TAB, EQUIPMENTS_FIELD);
    }
  },
  methods: {
    hasValue(value) {
      return formConfigHelper.isFilledValue(value);
    },
    columnWidth(width) {
      return { width: `${width}px`, minWidth: `${width}px` };
    },
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti.
    onItemBound() {
      this.ensureTableArrays(MANUFACTURE_EQUIPMENT_TAB);
      // Sel kosong yang default-nya bertanda fill_empty (mis. Type INALUM MCR001 "VALID") diisi -- sebelum preload label.
      this.fillEmptyColumnDefaults(MANUFACTURE_EQUIPMENT_TAB);
      this.preloadTabLabels(MANUFACTURE_EQUIPMENT_TAB);
    }
  }
};
</script>
